
export const SubmittingWorkProgress = {
  UPLOAD_WORK: "Uploading your work...",
  UPLOAD_PUBLIC_IMAGE: "Uploading your public image...",
  SAVE_WORK: "Saving your work...",
  PAYMENT: "Redirecting to payment...",
  MINTING: "Minting your NFT on the blockchain...",
  MINTING_COMPLETE: "NFT minted successfully!",
  FAILED: "Failed to upload your work please try again or contact us",
}